import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import subscriptionResponse from '../../testing/mocks/subscriptions';
import * as moment from 'moment'

class Summary extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: null,
            loggedIn: true, //todo: get from a central source
            hasSubscription: true, //todo: get from a central source
            apiResponse: null
        }
        subscriptionResponse().then(async (res)=>{
            let response = await res.json()
            this.setState({apiResponse: response})
        })
    }

    render() {

        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }

        if (!this.state.loggedIn || !this.state.hasSubscription) {
            this.setState({
                redirect: "/subscribe/choose"
            });
        }

        let first = true;

        return (
            <React.Fragment>
                <link rel="stylesheet" type="text/css" href="/styles/subscribe.css" />

                <h1>Extend Subscriptions</h1>
                <p>Please select the subscription you would like to extend.</p>

                <div class="table-responsive text-center">
                    <h3 class="subheader-text">Valid Subscriptions</h3>
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Student Count</th>
                                <th>Start Date</th>
                                <th>Expiration Date</th>
                                <th></th>
                            </tr>
                        </thead>

                        {/* todo: dropdown??  
                          */}

                        <tbody>
                            {this.state.apiResponse?.validSubscriptions?.map(((student, index) => {

                                // let expDate = new Date(student.expirationDate);
                                // let currentDate = new Date();

                                // // determine red background color (red if expiring within 3 months)
                                // let expireSoon = expDate.getMonth() - currentDate.getMonth() <= 3;

                                // first valid subscription (expiring soonest) that is not a trial has red background
                                let isRed = false;
                                if (first && student.future == null) {
                                    isRed = true;
                                    first = false;
                                }

                                let actionCol = (
                                    <td>
                                        <Link to={"/subscribe/extend?students=" + student.count + "&start=" + student.startDate + "&exp=" + student.expirationDate + "&created=" + student.created}>
                                            <div class="btn btn-secondary btn-md">Extend</div>
                                        </Link>
                                    </td>
                                )

                                if (student.trial) {
                                    actionCol = (
                                        <td>
                                            <p class="extend-p">Trial Subscription</p>
                                        </td>
                                    )
                                }

                                //todo: add label for extended subscriptions

                                if (student.future != null) {

                                    let targetID = "extended-" + index

                                    return (
                                        <React.Fragment>
                                            <tr data-toggle="collapse" data-target={"#" + targetID} class="pointer accordion-toggle collapsed active">
                                                <td class="align-middle">{student.count}</td>
                                                <td class="align-middle">{moment(student.startDate).format("MMM D, YYYY")}</td>
                                                <td class="align-middle">{moment(student.expirationDate).format("MMM D, YYYY")}</td>
                                                <td>
                                                    <p class="extend-p">Extended Subscription</p>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td colspan="6" class="nopadding">
                                                    <div class="accordian-body collapse" id={targetID}>
                                                        <table class="table" colspan="6">
                                                            <thead class="thead-light">
                                                                <tr>
                                                                    <td>Future Student Count</td>
                                                                    <td>Start Date</td>
                                                                    <td>Expiration</td>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td class="align-middle">{student.future.count}</td>
                                                                    <td class="align-middle">{moment(student.future.startDate).format("MMM D, YYYY")}</td>
                                                                    <td class="align-middle">{moment(student.future.expirationDate).format("MMM D, YYYY")}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    )
                                }

                                return (
                                    <tr class={isRed ? "danger" : ""} >
                                        <td class="align-middle">{student.count}</td>
                                        <td class="align-middle">{moment(student.startDate).format("MMM D, YYYY")}</td>
                                        <td class="align-middle">{moment(student.expirationDate).format("MMM D, YYYY")}</td>
                                        {actionCol}
                                    </tr>
                                )
                            }))}

                            <tr>
                                <td>
                                    <p class="spacing-line"></p>
                                    <p>Total Students: {this.state.apiResponse?.totalStudents}</p>
                                </td>
                                <td colspan="4"></td>
                            </tr>
                        </tbody>


                    </table>
                </div>
                
                {this.state.apiResponse?.expiredSubscriptions?.length > 0 ? 
                                    <div class="table-responsive text-center">
                                    <h3 class="subheader-text">Expired Subscriptions</h3>
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Student Count</th>
                                                <th>Start Date</th>
                                                <th>Expiration Date</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                
                                        <tbody>
                                            {this.state.apiResponse?.expiredSubscriptions?.map((student => {
                                                let actionCol = (
                                                    <td>
                                                        <Link to={"/subscribe/extend?students=" + student.count + "&start=" + student.startDate + "&exp=" + student.expirationDate + "&created=" + student.created}>
                                                            <div class="btn btn-secondary btn-md">Extend</div>
                                                        </Link>
                                                    </td>
                                                )
                                                if (student.trial) {
                                                    actionCol = (
                                                        <td>
                                                            <p class="extend-p">Trial Subscription</p>
                                                        </td>
                                                    )
                                                }
                                                if (student.future != null) {
                                                    actionCol = (
                                                        <td>
                                                            <p class="extend-p">Extended Subscription</p>
                                                        </td>
                                                    )
                                                }
                                                return (
                                                    <tr>
                                                        <td class="align-middle">{student.count}</td>
                                                        <td class="align-middle">{moment(student.startDate).format("MMM D, YYYY")}</td>
                                                        <td class="align-middle">{moment(student.expirationDate).format("MMM D, YYYY")}</td>
                                                        {actionCol}
                                                    </tr>
                                                )
                                            }))}
                                        </tbody>
                
                
                                    </table>
                                </div>
                
            
            : ""}

                <p class="spacing-line"></p>
                <p class="small">Extending a subscription does not change the total students until a subscription has expired.</p>

            </React.Fragment>
        );
    }

}

export default Summary;
